import { render, staticRenderFns } from "./PurchasedItemHome.vue?vue&type=template&id=aa8fc57e&scoped=true&class=template"
import script from "./PurchasedItemHome.vue?vue&type=script&lang=js"
export * from "./PurchasedItemHome.vue?vue&type=script&lang=js"
import style0 from "./PurchasedItemHome.vue?vue&type=style&index=0&id=aa8fc57e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8fc57e",
  null
  
)

export default component.exports